<table cell-spacing="20">
  <thead>
    <tr>
      @if (rowSelect) {
        <th class="select-cell">&nbsp;</th>
      }
      @for (column of config.columns; track column.key) {
        <th
          [style.width]="column.width"
          [class.sortable-header]="column.sortable"
          [class.sort-active]="activeSortColumn === column.key"
          (click)="onSortColumn(column)"
          (keydown.enter)="onSortColumn(column)"
          (keydown.space)="onSortColumn(column)"
          [attr.tabindex]="column.sortable ? 0 : null"
          [attr.aria-sort]="activeSortColumn === column.key ? (sortDirection === 'asc' ? 'ascending' : 'descending') : (column.sortable ? 'none' : null)"
        >
          <span class="header-content">
            {{ column.label | translate }}
            @if (column.sortable) {
              <span class="sort-icon">
                @if (activeSortColumn === column.key) {
                  {{ sortDirection === 'asc' ? '↑' : '↓' }}
                } @else {
                  <span class="sort-icon-inactive">↕</span>
                }
              </span>
            }
          </span>
        </th>
      }
    </tr>
  </thead>
  <tbody>
    @for (item of elements; track $index; let r = $index) {
      <tr>
        @if (rowSelect) {
          <td class="select-cell">
            <input
              type="checkbox"
              [checked]="item.selected"
              [disabled]="item.disabled"
              (change)="onRowSelected(item)"
            />
          </td>
        }
        @for (column of config.columns; track column.key; let i = $index) {
          <td
            [ngClass]="{
              'option-column': i !== 0 && column.columnType === options,
              'standard-column': i !== 0 && column.columnType !== options
            }"
          >
            @switch (column.columnType) {
              @case (chip) {
                <app-chip
                  [size]="getChipSize(item['chipSize'], column.chipSize)"
                  [color]="getChipColor(item['chipColor'], column.chipColor)"
                  [value]="item[column.key]"
                />
              }
              @case (options) {
                <div class="option-container">
                  @if (item[column.key] === null || hideOptionIndex === r) {
                    {{ '' }}
                  } @else {
                    <app-select
                      id="{{ 'select' + r + '_' + i }}"
                      [options]="item[column.key]"
                      (handleSelect)="onOptionSelected($event, item, r)"
                    ></app-select>
                  }
                </div>
              }
              @default {
                <div class="cell">
                  @if (showEllipsis(item[column.key], column.maxLength)) {
                    <app-tooltip
                      [text]="item[column.key]"
                      [label]="getEllipsisText(item[column.key], column.maxLength)"
                    ></app-tooltip>
                  } @else {
                    <span class="text-cell">{{
                      item[column.key] || 'common.na' | translate
                    }}</span>
                  }
                </div>
              }
            }
          </td>
        }
      </tr>
    }
  </tbody>
</table>
@if (paginate) {
  <div class="table-footer">
    <app-paginator
      [length]="length"
      [pageSize]="pageSize"
      (pageChanged)="onPageChanged($event)"
      [reset]="dataReloadCounter"
    ></app-paginator>
  </div>
}
